var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22483 11.625H3.77483C2.20817 11.625 1.0165 11.0583 0.424835 10.0333C-0.166832 9.00833 -0.0584986 7.69167 0.724835 6.33333L2.94983 2.475C3.73317 1.125 4.8165 0.375 5.99983 0.375C7.18317 0.375 8.2665 1.125 9.04983 2.48333L11.2748 6.34167C12.0582 7.7 12.1665 9.01667 11.5748 10.0417C10.9832 11.0583 9.7915 11.625 8.22483 11.625ZM5.99983 1.625C5.28317 1.625 4.58317 2.15 4.03317 3.10833L1.80817 6.96667C1.25817 7.925 1.14983 8.79167 1.50817 9.41667C1.8665 10.0417 2.67483 10.3833 3.77483 10.3833H8.22483C9.32483 10.3833 10.1332 10.0417 10.4915 9.41667C10.8498 8.79167 10.7415 7.925 10.1915 6.96667L7.9665 3.10833C7.4165 2.15 6.7165 1.625 5.99983 1.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpWhite);
export default __webpack_public_path__ + "static/media/up-white.b152a5277289097a8ba9222e3950e970.svg";
export { ForwardRef as ReactComponent };